import classnames from '../../node_modules/classnames/index.js';
import { forwardRef, createElement } from 'react';
import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { addClassNameToChildren, wrapTextInSpan } from '../util/react.js';
import styles from '../styles/Button.module.scss';
import LoadingDots from './LoadingDots.js';
import useiOSActiveState from './useiOSActiveState.js';

var getButtonClassName = function (_a) {
    var _b;
    var color = _a.color, fakeDisabled = _a.fakeDisabled, unstyledDisabled = _a.unstyledDisabled, unstyledHover = _a.unstyledHover, variant = _a.variant;
    return classnames((_b = {},
        _b[styles["fake-disabled"]] = fakeDisabled,
        _b[styles["unstyled-disabled"]] = unstyledDisabled,
        _b[styles["unstyled-hover"]] = unstyledHover,
        _b[styles["variant-" + variant]] = !color,
        _b[styles["variant-" + variant + "-" + color]] = color,
        _b));
};
/**
 * A button component that's backwards compatible with <button>
 * elements but provides extra features.
 */
var Button = function (_a, ref) {
    var children = _a.children, className = _a.className, color = _a.color, disabled = _a.disabled, onTouchStart = _a.onTouchStart, submitting = _a.submitting, unstyledDisabled = _a.unstyledDisabled, unstyledHover = _a.unstyledHover, _b = _a.useDisabledAttribute, useDisabledAttribute = _b === void 0 ? true : _b, _c = _a.variant, variant = _c === void 0 ? "unstyled" : _c, rest = __rest(_a, ["children", "className", "color", "disabled", "onTouchStart", "submitting", "unstyledDisabled", "unstyledHover", "useDisabledAttribute", "variant"]);
    var buttonClassName = getButtonClassName({
        color: color,
        fakeDisabled: (disabled || submitting) && !useDisabledAttribute,
        unstyledDisabled: submitting || unstyledDisabled,
        unstyledHover: unstyledHover,
        variant: variant,
    });
    var handleTouchStart = useiOSActiveState(onTouchStart);
    return (createElement("button", __assign({ "aria-disabled": useDisabledAttribute ? undefined : disabled || submitting, className: classnames(buttonClassName, className), disabled: useDisabledAttribute ? disabled || submitting : undefined, onTouchStart: handleTouchStart, ref: ref }, rest),
        addClassNameToChildren(wrapTextInSpan(children), styles["wrapped" + (submitting ? "-invisible" : "")]),
        submitting ? createElement(LoadingDots, { type: "button" }) : null));
};
var Button$1 = forwardRef(Button);

export default Button$1;
export { getButtonClassName };
